
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M12 .51c14 0 8 19 0 19s-14-19 0-19v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.224 8.94a1 1 0 00.894.552h7.764a1 1 0 00.894-.553l1-2a1 1 0 00-.044-.972 1 1 0 00-.85-.475H7.118a1 1 0 00-.894 1.447l1 2zm8.12 9.447c1.762-2.365-.243-5.377-3.345-5.377-3.102 0-5.105 3.016-3.343 5.377M.5 23.49l4.133-10.386m14.712.055L23.5 23.492m-22.204-2h21.4m-6.255-4h4.646m-18.2 0H7.56","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    